import axios from "axios";

export const getHomeBanner = async (bannerId, token) => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API_URL}/getHomeBanner/${bannerId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw new Error(error.message);
  }
};
